import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const LeatherBondedCableKnitVest = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.LeatherBondedCableKnitVest.itemName}
      name={SS23.tops.LeatherBondedCableKnitVest.itemName}
      price={SS23.tops.LeatherBondedCableKnitVest.itemPrice}
      fabric={SS23.tops.LeatherBondedCableKnitVest.itemFabric}
      src={SS23.tops.LeatherBondedCableKnitVest.sizeChart}
      divId={SS23.tops.LeatherBondedCableKnitVest.shopifyDivId}
      mainId={SS23.tops.LeatherBondedCableKnitVest.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.LeatherBondedCableKnitVest.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.LeatherBondedCableKnitVest.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default LeatherBondedCableKnitVest;
